import {createApp} from 'vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import router from "./router";
import store from "./store/index";
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import '@vuepic/vue-datepicker/dist/main.css'
import './assets/admin.css'
import './assets/style.css'

import '@fortawesome/fontawesome-free/css/all.min.css'
import Notifications from '@kyvg/vue3-notification'
import VueCookies from 'vue-cookies';
import axios from "axios";
import $store from './store'
import {createI18n} from "vue-i18n";

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    $store.dispatch('loader/start');

    // Set preferred language header.
    config.headers['X-PREFERRED-LANG'] = $store.state.system.lang || 'en';
    return config;
}, function (error) {
    // Do something with request error
    $store.dispatch('loader/end');
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
    $store.dispatch('loader/end');
    return response;
}, function (e) {
    // Do something with response error
    $store.dispatch('loader/end');
    return Promise.reject(e)
});

import {numberFormats} from "./i18n";
import {dateTimeFormats} from "./i18n";
const i18n = createI18n({
    locale: 'bn',
    fallbackLocale: 'bn',
    messages: {},
    numberFormats: numberFormats,
    datetimeFormats: dateTimeFormats,
});
createApp(App)
    .component('EasyDataTable', Vue3EasyDataTable)
    .use(router)
    .use(store)
    .use(Notifications)
    .use(VueCookies)
    .use(i18n)
    .mount('#app')
